import React from 'react';
import { Navigation } from '../components/Navigation';
import { SaleHero } from '../components/SaleHero';
import { SaleWhyUs } from '../components/SaleWhyUs';
import { SaleServices } from '../components/SaleServices';
import { SaleFAQ } from '../components/SaleFAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { FloatingContact } from '../components/FloatingContact';
export function SalePage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-896">
      <Navigation data-id="element-897" />

      <main className="pt-[72px]" data-id="element-898">
        {' '}
        {/* Add padding top to account for fixed navigation */}
        <SaleHero data-id="element-899" />
        <Consultation data-id="element-900" />
        <SaleWhyUs data-id="element-901" />
        <SaleServices data-id="element-902" />
        <SaleFAQ data-id="element-903" />
        <Testimonials data-id="element-904" />
        <Consultation data-id="element-905" />
      </main>

      <Footer data-id="element-906" />
      <CookieBanner data-id="element-907" />
      <FloatingContact data-id="element-908" />
    </div>;
}